import { useEffect, useState } from 'react'
import { db } from '../lib/db'
import { flushOutbox } from '../lib/sync'

type SyncState = 'synced' | 'syncing' | 'offline' | 'pending'

export default function SyncBar() {
  const [state, setState] = useState<SyncState>('synced')
  const [pending, setPending] = useState(0)

  useEffect(() => {
    let timer: ReturnType<typeof setInterval>

    async function check() {
      const count = await db.outbox.count()
      setPending(count)
      if (!navigator.onLine) {
        setState('offline')
      } else if (count > 0) {
        setState('syncing')
        flushOutbox()
          .then(async () => {
            const remaining = await db.outbox.count()
            setPending(remaining)
            setState(remaining > 0 ? 'pending' : 'synced')
          })
          .catch(() => setState('pending'))
      } else {
        setState('synced')
      }
    }

    check()
    timer = setInterval(check, 15000)
    window.addEventListener('online',  check)
    window.addEventListener('offline', check)

    return () => {
      clearInterval(timer)
      window.removeEventListener('online',  check)
      window.removeEventListener('offline', check)
    }
  }, [])

  if (state === 'synced') return null   // 已同步時不顯示

  const MAP = {
    syncing: { cls: 'sync-syncing', icon: '↻', text: '同步中…' },
    offline: { cls: 'sync-offline', icon: '✕', text: `離線 · ${pending} 筆待上傳` },
    pending: { cls: 'sync-pending', icon: '↑', text: `${pending} 筆待上傳` },
  } as const

  const { cls, icon, text } = MAP[state as keyof typeof MAP]

  return (
    <div className={`sync-bar ${cls}`}>
      <span style={{ fontWeight: 700, fontSize: '0.9em' }}>{icon}</span>
      {text}
    </div>
  )
}
